<!-- <nz-form-item>
    <nz-form-label [nzRequired]="field.required">{{ field.label
        }}</nz-form-label>

    <nz-form-control [nzErrorTip]="getErrorTpl(field)"> -->
<nz-upload class="avatar-uploader" nzName="avatar" nzListType="picture-card" [nzShowUploadList]="false"
    (nzChange)="handleChange($event)" [nzDisabled]="field.readonly">
    @if (!getImageUrl(field.name)) {
    <span class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></span>
    <div class="ant-upload-text">Upload</div>
    } @else {
    <!-- @if(field.readonly){ -->
    <img nz-image style="width: 100%;object-fit: contain;height: 100%;" [nzDisablePreview]="!field.readonly"
        [nzSrc]="getImageUrl(field.name)" alt="" />
        
    <!-- }
            @else {
                <img [src]="getImageUrl(field.name)" style="width: 100%;object-fit: contain;height: 100%;" />
            } -->
    }
    <span *ngIf="hasValue(field)" (click)="deleteImage($event)" class="center-text" nz-icon [nzType]="'delete'"></span>
</nz-upload>
<!--*ngIf="hasValue()" <input [hidden]="true" nz-input [formControl]="controlName" /> -->
<!-- </nz-form-control>
</nz-form-item> -->